import { useState } from "react";
import NepaliDatepicker from "./NepaliDatepicker";
import EnglishDatepicker from "./EnglishDatepicker";
import ResultBox from "./ResultBox";
import { motion } from "framer-motion";
import { bsToAd } from "../utils/bsToAd";
import { adToBs } from "../utils/adToBs";

// Helper function to zero-pad and format BS date as "YYYY/MM/DD"
function padBSParts(dateStr) {
  const parts = dateStr.split("-");
  if (parts.length !== 3) return dateStr;
  const padded = parts.map((v, i) => (i === 0 ? v : v.padStart(2, "0")));
  return padded.join("/");
}

export default function ConverterCard({ mode }) {
  const [input, setInput] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleConvert = () => {
    setError("");
    setResult("");
    try {
      if (mode === "BS2AD") {
        // Use helper to reformat for the converter
        const formattedInput = padBSParts(input);
        const ad = bsToAd(formattedInput);
        setResult(ad ? ad.toLocaleDateString() : "");
        setError(ad ? "" : "Invalid BS date");
      } else {
        const bs = adToBs(input);
        setResult(bs || "");
        setError(bs ? "" : "Invalid AD date");
      }
    } catch {
      setError("Error converting date");
    }
  };

  const handleClear = () => {
    setInput("");
    setResult("");
    setError("");
  };

  return (
  <motion.div
    className="glassmorphism-card"
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
  >
    {mode === "BS2AD" ? (
      <NepaliDatepicker value={input} onChange={setInput} />
    ) : (
      <EnglishDatepicker value={input} onChange={setInput} />
    )}

    <div style={{ display: "flex", gap: "16px", marginTop: "28px", justifyContent: "flex-start" }}>
      <motion.button
        className="convert-btn"
        whileHover={{ scale: 1.04 }}
        onClick={handleConvert}
      >
        Convert
      </motion.button>
      <button onClick={handleClear} className="clear-btn">
        Clear
      </button>
    </div>

    <ResultBox result={result} error={error} />
  </motion.div>
)

}
